import gql from "graphql-tag.macro";

const loadCurrentContextQuery = gql`
    query currentInstance {
        currentInstance {
            ... on Instance {
                _id
                _account
                _organisation
                projects {
                    edges {
                        node {
                            _id
                            legacyId
                        }
                    }
                }
            }
        }
    }
`;

const loadCurrentWorkflowInstanceContextQuery = gql`
query currentWorkflowInstance ($docId: ID!){
    v2document(id:$docId) {
        workflowinstance {
            _id
        }
    }
}
`;

export const loadCurrentContext = async ({ client }) => {
    const {
        data: {
            currentInstance: {
                _account: account,
                _id: instance,
                _organisation: organisation,
                projects: { edges }
            },
        },
    } = await client.query({
        query: loadCurrentContextQuery,
    });
    return {
        account,
        instance,
        organisation,
        projectEdges: edges 
    };
};

export const loadCurrentWorkflowInstanceContext = async ({ docId }, { client, mdContext }) => {
    const {
        data: {
            v2document: {
                workflowinstance: data
            },
        },
    } = await client.query({
        query: loadCurrentWorkflowInstanceContextQuery,
        variables: { docId },
        fetchPolicy: "no-cache"
    });
    return data;
};
